import { inject } from "@angular/core";
import { type ActivatedRouteSnapshot, type ResolveFn, Router } from "@angular/router";

import { catchError, map, of } from "rxjs";

import type { SupplierDetail } from "../shared/models";
import { SupplierService } from "../supplier.service";

/**
 * Resolve supplier data before activating the detail route.
 * Redirects to 404 if the supplier is not found.
 */
export const supplierDetailResolver: ResolveFn<SupplierDetail | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const supplierService = inject(SupplierService);
  const router = inject(Router);

  const id = route.paramMap.get("id");

  if (!id) {
    router.navigate(["/404"]);
    return of(null);
  }

  return supplierService.getSupplier(id).pipe(
    map((supplier) => supplier),
    catchError(() => {
      router.navigate(["/404"]);
      return of(null);
    }),
  );
};
